<template>
  <x-table
    :changeCheckState="changeCheckState"
    :showSelectAll="true"
    :columns="columns"
    :updateTableSize="updateTableSize"
    :showResults="false"
    pageSizeOption="OPTION_2"
    :selectAllItems="(status) => this.$emit('selectAll',status)"
    :loading="loading"
    :selectedItems="versionsIds"
    :tableRows="versions"
    :paginationData="{
      pageSize,
      pageNumber,
      totalRecords,
      setPage,
    }"
    data-test-id="versions-table"
  >
    <template slot="table_item" slot-scope="props">
      <tr
        v-for="{
          source: { fileName, fileSize, updatedOn, version },
          archiveId: id,
        } in props.tableRows"
        :key="id"
      >
        <td>
          <Checkbox
            :value="id"
            v-model="props.selectedItems"
            theme="light"
            @click="select"
          ></Checkbox>
        </td>
        <td style="max-width: 200px">
          <span>{{ fileName }}</span>
        </td>
        <td width="20%">
          <span>{{ FileSizeConverter(fileSize) }}</span>
        </td>
        <td>
          <span>{{ getFormatedDateAsPerTimeAndDate(updatedOn) }}</span>
        </td>
        <td class="text-center">
          <span>{{ version }}</span>
        </td>
      </tr>
    </template>
  </x-table>
</template>
<script>
import Checkbox from '@/components/Common/Checkbox';
import FileSizeConverter from '@/helpers/FileSizeConverter';
export default {
  name: 'VersionsTable',
  props: ['loading', 'versionsIds', 'modalOpen', 'versions', 'changeCheckState'],
  components: {
    Checkbox,
  },
  data() {
    return {
      FileSizeConverter,
      pageNumber: 1,
      totalRecords: null,
      pageSize: 5,
      columns: [
        { label: 'File name' },
        { label: 'Size ' },
        { label: 'Synced at' },
        { label: 'Version' },
      ],
      contentLoading: true,
    };
  },
  watch: {
    modalOpen: async function () {
      if (this.modalOpen) {
        this.pageNumber = 1;
        this.pageSize = 5;
      }
    },
  },
  methods: {
    /**
     * emitted when table display count changes
     * @param {Number} newVal
     */
    updateTableSize(newVal) {
      this.pageSize = newVal;
      this.pageNumber = 1;
      this.$emit('getVersions',{
          pageSize: this.pageSize,
          pageNumber: this.pageNumber
      });
    },
    /**
     * emitted from pagination
     * @param {Number} page
     */
    setPage(page) {
      this.pageNumber = page;
      this.$emit('getVersions',{
          pageSize: this.pageSize,
          pageNumber: this.pageNumber
      });
    },
    select(selected) {
        this.$emit('select',selected);
    }
  },
};
</script>